export default function SkeletonDataTable() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse">
      {/* Header row */}
      <div className="flex gap-4 mb-4 pb-4 border-b">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} className="h-4 bg-gray-200 rounded flex-1"></div>
        ))}
      </div>
      {/* Data rows */}
      {[1,2,3,4,5,6,7,8].map(row => (
        <div key={row} className="flex gap-4 mb-3">
          <div className="h-10 w-10 bg-gray-200 rounded"></div>
          {[1,2,3,4,5].map(col => (
            <div key={col} className="h-4 bg-gray-200 rounded flex-1"></div>
          ))}
        </div>
      ))}
    </div>
  );
}
